import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";

const ITEMS = ["browser", "quick", "social", "workshop", "character", "wiki", "settings", "credits", "quit"];

/* Left-aligned vertical nav (spec §2): 46px bars, accent rule flash on focus,
   +6px label shift, gradient wipe, full keyboard navigation. */
export function MainMenuNav({ onSelect, audio, accent = "#2E6BFF" }) {
  const [focus, setFocus] = useState(0);
  const { t } = useI18n();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowDown") { e.preventDefault(); setFocus((f) => (f + 1) % ITEMS.length); audio.tick(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setFocus((f) => (f - 1 + ITEMS.length) % ITEMS.length); audio.tick(); }
      else if (e.key === "Enter") { e.preventDefault(); onSelect(ITEMS[focus]); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [focus, onSelect, audio]);

  return (
    <nav data-testid="main-menu" className="flex flex-col w-[320px] sm:w-[380px]">
      {ITEMS.map((id, i) => {
        const active = focus === i;
        return (
          <button
            key={id}
            data-testid={`nav-${id}`}
            onMouseEnter={() => { if (focus !== i) { setFocus(i); audio.tick(); } }}
            onClick={() => onSelect(id)}
            className="relative h-[46px] flex items-center text-left outline-none transition-transform duration-[60ms] active:scale-[0.985]"
            style={{ animation: `ncSlideL 0.5s cubic-bezier(0.16,1,0.3,1) ${0.12 + i * 0.07}s both` }}
          >
            <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-[26px] transition-colors duration-[80ms]"
              style={{ backgroundColor: active ? accent : "transparent", boxShadow: active ? `0 0 12px ${accent}` : "none" }} />
            <span className="absolute inset-0 transition-opacity duration-[80ms]"
              style={{ background: `linear-gradient(90deg, ${accent}14 0%, transparent 70%)`, opacity: active ? 1 : 0 }} />
            <span className="relative pl-5 font-medium uppercase text-[19px] sm:text-[20px] transition-all duration-[80ms]"
              style={{ letterSpacing: "0.08em", color: active ? "#fafafa" : "#8b93a7", transform: active ? "translateX(6px)" : "none" }}>
              {t(`nav.${id}`)}
            </span>
            <span className="absolute right-3 font-mono text-[9px] tracking-[0.3em] uppercase transition-opacity duration-[80ms]"
              style={{ color: accent, opacity: active ? 1 : 0 }}>
              {String(i + 1).padStart(2, "0")}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
